import { cn } from '@/common/lib/utils'

import type { components } from '@/schema'

import { MessageTextRenderer } from '../MessageTextRenderer'

type ChatMessageResponse = components['schemas']['ChatMessageResponse']

interface SystemMessageProps {
	message: ChatMessageResponse
	className?: string
}

/**
 * SystemMessage component renders system notifications in the chat
 * These are internal messages (e.g., admin joined/left) that are not sent to LINE users
 */
export function SystemMessage({ message, className }: SystemMessageProps) {
	const isReadDivider = message.id.startsWith('unread-divider')

	return (
		<div
			data-message-id={message.id}
			className={cn('flex flex-col items-center', className)}
		>
			<div
				className={cn(
					'flex flex-col items-center rounded-lg bg-muted/80 px-2 py-1 text-xs text-muted-foreground/80',
					isReadDivider && 'w-[95%]',
				)}
			>
				{!isReadDivider && message.createdAt && (
					<span className="mb-1 text-[10px]">
						{new Date(message.createdAt).toLocaleTimeString('th-TH', {
							hour: '2-digit',
							minute: '2-digit',
						})}
					</span>
				)}
				<div className="flex items-center justify-center">
					<span>
						<MessageTextRenderer text={message.text} />
					</span>
				</div>
			</div>
		</div>
	)
}
